import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(15)} 0;
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Tickets = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(20)};
    margin-bottom: ${rem(20)};
    justify-content: space-between;
    
    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
        &::-webkit-scrollbar {
            display: none;
        }
    }
`;

export const Ticket = styled.div<{ colors: IColors }>`
    background: ${(props) => props.colors.colorLightest};
    display: flex;
    flex-direction: column;
    text-align: center;
    padding-bottom: ${rem(25)};
    width: 50%;
    &:hover {
        background: ${(props) => props.colors.colorLight};
    }

    @media (max-width: ${breakpoints.sm}px) {
        width: 100%;
    }
`;

export const TicketTitle = styled.span<{ colors: IColors }>`
    background: ${(props) => props.colors.colorLink};
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding: ${rem(20)} ${rem(10)} ${rem(5)} ${rem(10)};
`;

export const TicketLabel = styled.span<{ colors: IColors }>`
    background: ${(props) => props.colors.colorLink};
    color: ${({ theme }) => theme.colors.white};
    padding: 0 0 ${rem(15)} 0;
`;

export const TicketQuestion = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding: ${rem(25)} ${rem(10)};
`;

export const TicketAnswers = styled.div`
    padding: 0 ${rem(10)};
    text-align: left;
    line-height: ${rem(25)};
`;

export const TicketAnswer = styled.div`
    padding: ${rem(10)} 0;
`;

export const TicketPriceWithButton = styled.div`
    margin-top: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const TicketPrice = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding: ${rem(20)} 0 0 0;
`;

export const TicketPriceNoVat = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    font-size: ${({ theme }) => theme.fontSizes.h7};
    padding: ${rem(8)} 0 ${rem(20)} 0;
`;

export const TicketButton = styled.button<{ colors: IColors }>`
    padding: ${rem(15)} ${rem(20)};
    margin: 0 auto;
    width: ${rem(200)};
    border-radius: ${rem(4)};
    cursor: pointer;
    border: none;
    background: ${(props) => props.colors.colorButton};
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    &:hover {
        background: ${(props) => props.colors.colorButtonHover};
    }

    @media (min-width: ${breakpoints.sm}px) {
        margin: 0 ${rem(10)};
    }
`;

export const TicketSoldOut = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding: ${rem(20)};
`;

export const TicketCanceled = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding: ${rem(20)};
`;

export const Tags = styled.div`
    margin-top: ${rem(20)};
    padding: ${rem(15)} 0;

    @media (min-width: ${breakpoints.md}px) {
        padding: 0;
    }
`;
